{
  "$id": "module://vesting-template",
  "$schema": "wealthlane://schemas/domain",
  "title": "Vesting Template",
  "description": "Vesting template field catalog — maps to Create/Update VestingTemplate DTO",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "name": {
      "type": "string",
      "title": "Vesting Template Name",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "summary": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "maxLength": 1000,
      "adapterProps": { "rows": 5 }
    },
    "vestingTypeId": {
      "$ref": "module://participant#/$defs/addressCountryId",
      "title": "Vesting Type"
    },
    "vestingType": {
      "type": "string",
      "title": "Vesting Type",
      "widget": "hidden"
    },
    "vestingTypeLabel": {
      "type": "string",
      "title": "Vesting Type Label",
      "widget": "hidden"
    },
    "isCliffVesting": {
      "type": "boolean",
      "title": "Is Cliff Vesting",
      "widget": "hidden",
      "default": false
    },
    "isStepVesting": {
      "type": "boolean",
      "title": "Is Step Vesting",
      "widget": "hidden",
      "default": false
    },
    "isHybridVesting": {
      "type": "boolean",
      "title": "Is Hybrid Vesting",
      "widget": "hidden",
      "default": false
    },
    "loadingTypeId": {
      "$ref": "module://participant#/$defs/addressCountryId",
      "title": "Loading Type"
    },
    "endOfTheMonthTypeId": {
      "$ref": "module://participant#/$defs/addressCountryId",
      "title": "Vest At End Of Month"
    },
    "specificVestingInstruction": {
      "type": "string",
      "title": "Specific Vesting Instruction",
      "widget": "textarea",
      "adapterProps": { "rows": 5 }
    },
    "periodStartDate": {
      "type": "string",
      "title": "Period Start Date",
      "widget": "date",
      "format": "date"
    },
    "lengthInMonths": {
      "type": "number",
      "title": "Term Period",
      "widget": "number",
      "minimum": 1,
      "maximum": 999,
      "digitsOnly": true
    },
    "cliffPeriodHelperNote": {
      "type": "string",
      "title": "After the specified vesting period the vesting will end.",
      "default": "After the specified vesting period the vesting will end.",
      "widget": "label"
    },
    "vestsAfterInMonths": {
      "type": "number",
      "title": "Cliffs",
      "widget": "number",
      "minimum": 0,
      "maximum": 999,
      "digitsOnly": true
    },
    "vestsInMonths": {
      "type": "number",
      "title": "Vests In Months",
      "widget": "hidden"
    },
    "amountOneInPercentage": {
      "type": "number",
      "title": "Cliff Percent",
      "widget": "number",
      "minimum": 0,
      "maximum": 100,
      "inputPrecision": 4,
      "displayPrecision": 4
    },
    "intervalInMonths": {
      "type": "number",
      "title": "Vesting Frequency",
      "widget": "number",
      "minimum": 1,
      "maximum": 999,
      "digitsOnly": true
    },
    "roundingTypeId": {
      "$ref": "module://participant#/$defs/addressCountryId",
      "title": "Rounding Type"
    },
    "fractionalDecimalDigit": {
      "type": "number",
      "title": "Fractional Decimal Digit",
      "widget": "hidden",
      "default": 0
    },
    "vestAtEndOfMonth": {
      "type": "boolean",
      "title": "Vest At End Of Month Flag",
      "widget": "hidden",
      "default": false
    }
  }
}
